export const checkStringForPattern = (name: string, disallowedCharacters: RegExp) => {
  return !!name.match(disallowedCharacters);
};

export const removeCharactersFromString = (str: string, pattern: RegExp) => {
  if (str.replaceAll) {
    return str.replaceAll(pattern, '');
  }
  return str.replace(pattern, '');
};
